import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiRobot2Fill } from '@remixicon/react';
import { z } from 'zod';
import { registerComponentRouteRef, rootRoute } from './routes';

const aiCatalogPage = PageBlueprint.makeWithOverrides({
  configSchema: {
    // Omitting columns and actions for now as their types are too complex to map to zod
    initiallySelectedFilter: z.enum(['owned', 'starred', 'all']).optional(),
  },
  factory(originalFactory, { config }) {
    return originalFactory({
      path: '/ai-catalog',
      routeRef: rootRoute,
      title: 'AI Resources',
      icon: <RiRobot2Fill />,
      loader: () =>
        import('./components/AiCatalogPage/DefaultAiCatalogPage').then(m => (
          <m.NfsAiCatalogPage
            initiallySelectedFilter={config.initiallySelectedFilter}
          />
        )),
    });
  },
});

export default createFrontendPlugin({
  pluginId: 'ai-catalog',
  title: 'AI resource catalog',
  icon: <RiRobot2Fill />,
  info: { packageJson: () => import('../package.json') },
  featureFlags: [
    {
      name: 'ai-resources-enabled',
      description: 'Enable MCP and Ai Resources catalog',
    },
  ],
  if: { featureFlags: { $contains: 'ai-resources-enabled' } },
  routes: {
    root: rootRoute,
  },
  externalRoutes: {
    registerApi: registerComponentRouteRef,
  },
  extensions: [aiCatalogPage],
});
